import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const DeleteConfirmationModal = ({ show, handleClose, handleDelete, content, toBeDeleted }) => {


    return (
        <Modal show={show} onHide={handleClose}>
                {content}
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>No</Button>
                <Button variant="primary" onClick={handleDelete}>Yes</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
